import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "select"]
  static values = { url: String }

  toggle(event) {
    event.preventDefault()
    if (this.selectTarget.classList.contains("hidden")) {
      this.displayTarget.classList.add("hidden")
      this.selectTarget.classList.remove("hidden")
      this.selectTarget.focus()
    } else {
      this.close()
    }
  }

  change() {
    const value = this.selectTarget.value
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ owner_id: value })
    }).then(response => {
      if (response.ok) window.location.reload()
    })
  }

  close() {
    this.displayTarget.classList.remove("hidden")
    this.selectTarget.classList.add("hidden")
  }

  handleBlur() {
    setTimeout(() => this.close(), 150)
  }
}
